import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import i18n from 'i18next';
import _ from 'lodash';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
import Input from '../ui/input';
import Validator from '../../utils/validator';
import { createBillboardTypeAPI, editBillboardTypeAPI, getBillboardTypeList } from '../../api/settingAPI';
import { setBillboardTypeList } from '../../redux/app';
var t = i18n.getFixedT(null, 'setting-billboard');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var BillboardTypeEdit = /*#__PURE__*/React.memo(function (_ref) {
  var id = _ref.id,
      mode = _ref.mode,
      currentEditType = _ref.currentEditType,
      handleIsModified = _ref.handleIsModified,
      onClose = _ref.onClose;

  // component logic here
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot;

  var dispatch = useDispatch();
  var formRef = React.useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(function () {
    if (mode === 'edit' && currentEditType) {
      return _objectSpread({}, currentEditType);
    }

    return {};
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formData = _useState4[0],
      setFormData = _useState4[1];

  var fields = {};
  var actions = {};

  var handleClose = function handleClose() {
    if (onClose) onClose();
  };

  var handleConfirm = function handleConfirm() {
    var fillOutRequired = Validator(['text'], formData);

    if (fillOutRequired.length > 0) {
      setError(et('txt-fill-out-required'));
      return;
    }

    var confirmApi = mode === 'edit' ? editBillboardTypeAPI : createBillboardTypeAPI;
    var data = {
      name: formData.text
    };

    if (mode === 'edit' && currentEditType) {
      data.id = currentEditType.value;
    }

    confirmApi(contextRoot, false, data).then(function () {
      getBillboardTypeList(contextRoot, true).then(function (result) {
        var newList = _.map(result.content, function (el) {
          return {
            value: _.trim(el.id),
            text: el.name
          };
        });

        dispatch(setBillboardTypeList(newList));
        handleClose();
        setError(null);
      });
      handleIsModified(true);
    }).catch(function (err) {
      setError(et(err.code || '-1'));
    });
  };

  var handleChange = function handleChange(field, value) {
    var newFormData = _objectSpread({}, formData);

    _.set(newFormData, field, value);

    setFormData(newFormData);
  };

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: handleClose
  });

  _.set(actions, 'confirm', {
    text: gt('global.lbl-answer-ok'),
    className: 'button-success',
    // disabled: !formValid,
    handler: handleConfirm
  });

  if (mode === 'edit' && currentEditType) {
    _.set(fields, 'text', {
      label: t('lbl-type'),
      width: '320px',
      formatter: function formatter(val) {
        return /*#__PURE__*/React.createElement("p", {
          style: {
            minWidth: '300px',
            margin: '0'
          }
        }, val);
      }
    });
  }

  _.set(fields, 'text', {
    label: t('lbl-type'),
    width: '320px',
    formatter: function formatter(val) {
      return /*#__PURE__*/React.createElement(Input, {
        id: "".concat(id, "-type-text"),
        validate: {
          required: true,
          t: function t(code) {
            return et("txt-".concat(code));
          }
        },
        value: val || '',
        onChange: function onChange(v) {
          return handleChange('text', v);
        },
        style: {
          width: '300px'
        }
      });
    }
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t("dlg-billboard-type-setting-".concat(mode)),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form"),
    ref: formRef,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: handleChange,
    value: formData
  }));
});
BillboardTypeEdit.defaultProps = {
  mode: 'create',
  currentEditType: null
};
BillboardTypeEdit.propTypes = {
  mode: PropTypes.string,
  currentEditType: PropTypes.object,
  handleIsModified: PropTypes.func,
  onClose: PropTypes.func
};
export default BillboardTypeEdit;